import { createContext, useContext } from "react";

/**
 * When `true`, the leads "Visits From" filter allows only one country (or worldwide / region).
 * Scoring criteria use this mode; the opportunity-list panel allows multi-country OR selection.
 *
 * Defaults to `null` (multi-country). See ADR-0005 (module behaviour injection via React context).
 */
const VisitsFromSingleCountryContext = createContext<boolean | null>(null);
VisitsFromSingleCountryContext.displayName = "VisitsFromSingleCountryContext";

export const VisitsFromSingleCountryProvider = VisitsFromSingleCountryContext.Provider;

export const useInjectedVisitsFromSingleCountry = (): boolean | null => useContext(VisitsFromSingleCountryContext);
